<!--Loading State-->
<ng-container
  *ngIf="isLoading && (precerts === null || precerts?.length === 0)"
>
  <div class="cg-flex-center cg-margin-top-lg cg-margin-bottom-lg">
    <div class="cg-spinner"></div>
  </div>
</ng-container>

<!--Empty State-->
<div
  *ngIf="precerts?.length === 0 && isLoading === false"
  class="tile-section flew-row empty-state-stlying"
>
  <p data-test="EmptyState">
    {{
      isFlagTile
        ? ('dashboard.noFlaggedPrecerts' | translate)
        : ('dashboard.noRecentSearchesPrecert' | translate)
    }}
  </p>
  <a routerLink="/patient/search">
    <strong>{{ 'dashboard.searchNow' | translate }}</strong>
  </a>
</div>

<!-- Data state -->
<ng-container *ngIf="precerts?.length > 0">
  <div class="flag-list">
    <div *ngFor="let precert of precerts" class="tile-section">
      <cigna-precert-detail-item
        [isEditable]="isEditable"
        [isRestrictedImpersonator]="isRestrictedImpersonator"
        [precert]="precert"
        [flaggedKeys]="flaggedKeys"
        [isFlagView]="isFlagTile"
        (flag)="flag.emit($event)"
      ></cigna-precert-detail-item>
    </div>
  </div>
</ng-container>
